var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52851 11.5287C5.26816 11.789 5.26816 12.2111 5.52851 12.4715C5.78886 12.7318 6.21097 12.7318 6.47132 12.4715L10.4713 8.47149C10.7317 8.21114 10.7317 7.78903 10.4713 7.52868L6.47132 3.52868C6.21097 3.26833 5.78886 3.26833 5.52851 3.52868C5.26816 3.78903 5.26816 4.21114 5.52851 4.47149L9.05711 8.00008L5.52851 11.5287Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.20377e1471117542c5cfa7d5e16befaa.svg";
export { ForwardRef as ReactComponent };